"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

const STORAGE_KEY = "theme";

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  React.useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "silk" || (stored && !["light", "dark", "system"].includes(stored))) {
        localStorage.setItem(STORAGE_KEY, "system");
      }
    } catch {
      // Ignore storage errors in restricted environments.
    }
  }, []);

  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
